module.exports = __webpack_public_path__ + "tenants-manage.97b49235d9f68dff6edea57a522eb418.hashedasset.png";


//////////////////
// WEBPACK FOOTER
// ./app/img/tenants/intro/tenants-manage.png
// module id = 6994416230133603
// module chunks = 1